module.exports = __webpack_public_path__ + "img/copy-gray.0eecb269.svg";